import * as angular from 'angular';
import controller from './hourlyCheckReport.controller';
import template from './hourlyCheckReport.tpl.html';

export default angular.module('aps.directive.hourlyCheckReport', [controller])
  .directive('apsHourlyCheckReport', hourlyCheckReportDef)
  .name;

function hourlyCheckReportDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'HourlyCheckReportCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      plant: '=',
      numHours: '=',
      wellKnownCheck: '=',
      showDetails: '='
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checkLists/hourlyCheckReport.directive.ts